import { Checkbox, FormControlLabel, FormHelperText, Stack } from '@mui/material';
import type { FieldRendererProps } from '../types';

export function CheckboxInput({ name, label, value, error, onChange }: FieldRendererProps) {
  return (
    <Stack spacing={0.5}>
      <FormControlLabel
        control={
          <Checkbox
            name={name}
            checked={value === true}
            onChange={(e) => onChange(e.target.checked)}
          />
        }
        label={label}
      />
      {error && <FormHelperText error>{error}</FormHelperText>}
    </Stack>
  );
}
